import React, { useEffect } from 'react';
// import { useTranslation } from 'react-i18next';

const ImpressumPage: React.FC = () => {
  // const { t, i18n } = useTranslation();
  // const currentLang = i18n.language;
  const currentLang = 'en'; // Default to English

  useEffect(() => {
    document.title = `Legal Notice | Fork:it`; // Always English: {currentLang === 'de' ? 'Impressum' : 'Legal Notice'}
  }, []); // Removed currentLang from dependencies

  return (
    <div className="bg-white">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <h1 className="text-4xl md:text-5xl font-lexend font-bold mb-12 text-center">
          Legal Notice
        </h1>

        <div className="max-w-3xl mx-auto prose lg:prose-lg">
          <h2>Information pursuant to § 5 TMG</h2>
          
          <p>
            SEN.CO UG (haftungsbeschränkt)<br />
            Paradiesgasse 53<br />
            60594 Frankfurt am Main<br />
            Germany
          </p>

          <h2>Represented by</h2>
          <p>Denis Kreuzer</p>

          <h2>Contact</h2>
          <p>
            Phone: +49 155 66179807<br />
            E-Mail: sound@sen.studio
          </p>

          <h2>Commercial Register</h2>
          <p>
            Registered in the Commercial Register<br />
            Register Court: Amtsgericht Frankfurt am Main<br />
            Registration Number: HRB 129222
          </p>

          <h2>VAT ID</h2>
          <p>
            VAT identification number according to § 27 a of the German Value Added Tax Act:<br />
            DE355008917
          </p>

          <h2>Dispute Resolution</h2>
          <p>
            The European Commission provides a platform for online dispute resolution (OS): <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.<br />
            Our e-mail address can be found above in the site notice.
          </p>
          <p>
            We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.
          </p>

          {/* Additional sections like Haftungsausschluss, Urheberrecht, etc. should be added here if they existed in the original German version */}
          <h3>Disclaimer</h3>
          <h4>Liability for Content</h4>
          <p>
            As a service provider, we are responsible for our own content on these pages in accordance with general laws pursuant to Section 7 (1) TMG. According to Sections 8 to 10 TMG, however, we as a service provider are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.
          </p>
          <p>
            Obligations to remove or block the use of information in accordance with general laws remain unaffected. However, liability in this regard is only possible from the point in time at which knowledge of a specific infringement of the law is obtained. Upon notification of corresponding infringements, we will remove this content immediately.
          </p>

          <h4>Liability for Links</h4>
          <p>
            Our offer contains links to external websites of third parties, over whose content we have no influence. Therefore, we cannot assume any liability for this external content. The respective provider or operator of the pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking.
          </p>
          <p>
            However, permanent content control of the linked pages is not reasonable without concrete evidence of an infringement. Upon notification of infringements, we will remove such links immediately.
          </p>

          <h4>Copyright</h4>
          <p>
            The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution, and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator. Downloads and copies of this site are only permitted for private, non-commercial use.
          </p>
          <p>
            Insofar as the content on this site was not created by the operator, the copyrights of third parties are respected. In particular, third-party content is identified as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. Upon notification of infringements, we will remove such content immediately.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage; 